import React from "react";
import { LatestAlertsTable } from "features/alert/latestAlertTable";

export const AlertTable = () => {
  return <LatestAlertsTable />;
};
